import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import store from './store';
import axios from './server/axios.js';
import server from './server';
import utils from './utils'
import 'element-ui/lib/theme-chalk/index.css';    // 默认主题
import "../theme/main.css";
// import "../theme/color-dark.css";     /*深色主题*/
import "../theme/theme-green/color-green.css";  
import '../theme/theme-green/index.css';     
import "babel-polyfill";
import 'font-awesome/scss/font-awesome.scss';

Vue.use(ElementUI, { size: 'small' });
Vue.use(server);
Vue.use(utils);

Vue.prototype.$axios = axios;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');